/**
 * JWTトークンの形式が有効かどうかを判定します。
 *
 * デコード前に `header.payload.signature` の3パート構造を持つことだけを検証します。
 * 署名の正当性やペイロードの内容はチェックしません。
 *
 * @param token 検証対象の文字列。
 * @returns 3パート構造を持つ場合は true。
 */
export function isWellFormedJwt(token: string): boolean {
  return token.split(".").length === 3;
}

/**
 * トークンのデバッグ用メタデータを安全に生成します。
 *
 * トークン本体は含めず、長さとパート数のみを返します。
 */
export function describeTokenShape(token: unknown): Record<string, unknown> {
  if (typeof token !== "string") {
    return { type: typeof token, present: token != null };
  }
  return {
    length: token.length,
    parts: token.split(".").length,
  };
}
